import * as moment from 'moment';

export class AppFormat {
    public static dateDMY(d) {
        var dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/

        if (d && dateReg.test(d)) {
          // console.log(d);
          let dt = d.split('-');
          let f = dt[2]+'/'+dt[1]+'/'+dt[0];
          return f;
        } else {
          return '';
        }
    }

    public static formatDateYMD(d) {
        var dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/

        if (d && dateReg.test(d)) {
          // console.log(d);
          let dt = d.split('-');
          let f = dt[2]+'/'+dt[1]+'/'+dt[0];

          return f;
        } else {
          return '';
        }
    }

    public static formatFullDate(d, withyear) {
      var dateReg = /^\d{4}([./-])\d{2}\1\d{2} \d{2}:\d{2}:\d{2}$/

      if (d && dateReg.test(d)) {
        // console.log(d);
        let dt = d.split(' ')
        let date = dt[0].split('-')
        let f = date[2]+'/'+date[1]

        if (withyear) f += '/'+date[0]

        return f
      } else {
        return ''
      }
    }

    public static formatHour(d) {
      var dateReg = /\d{2}:\d{2}:\d{2}$/

      if (d && dateReg.test(d)) {
        // console.log(d);
        let dt = d.split(' ')
        let hour = dt[1].split(':')

        let f = hour[0]+':'+hour[1]
        return f
      } else {
        return ''
      }
    }

    public static simplyHour(d) {
      var dateReg = /\d{2}:\d{2}$/

      if (d && dateReg.test(d)) {
        // console.log(d);
        let hour = d.split(':')

        let f = hour[0]+':'+hour[1]
        if (hour[1]=='00') {
          return hour[0]+'h'
        } else {
          return f
        }
      } else {
        return ''
      }
    }

    public static formatDuration(s) {
      if (s >= 60) {
        let m = s / 60
        if (m >= 60) {
          let h = m / 60
          let horas = parseInt(h.toFixed(0))
          let min = h - horas

          return horas + ' h ' + (min * 60).toFixed(0) + ' min'

        } else {

          let min = parseInt(m.toFixed(0))

          return min + ' min'
        }
      } else {
        return s + ' s'
      }
    }

    public static formatWeekName(date) {
      var dateReg = /^\d{4}([./-])\d{2}\1\d{2}/

      if (date && dateReg.test(date)) {

        let weekName = {
          1: 'Domingo',
          2: 'Segunda-feira',
          3: 'Terça-feira',
          4: 'Quarta-feira',
          5: 'Quinta-feira',
          6: 'Sexta-feira',
          7: 'Sábado'
        }

        let dt = date.split(' ')
        let d = dt[0].split('-')

        let da = new Date(d[0], parseInt(d[1]) - 1, d[2])

        return weekName[da.getDay()+1]
      } else {
        return ''
      }
    }

    public static getDay(d) {
      if (d == null) return

      var dt = new Date()

      let m = dt.getMonth()+1
      let a = dt.getFullYear()

      var yt = new Date()

      yt.setDate(dt.getDate() - 1);

      let r = d.split('/');
      let dd = parseInt(r[0])
      let dm = parseInt(r[1])
      let da = parseInt(r[2])

      if (a == da) {
        if (m == dm) {
          if (dt.getDate() == dd) {
            return 'Hoje'
          } else if (yt.getDate() == dd) {
            return 'Ontem'
          } else {
            return 'Dia '+r[0]
          }
        } else {
          return 'Dia '+r[0]+'/'+r[1]
        }
      } else {
        return d
      }
    }

    public static getDateDescription(d) {
      if (d == null) return

      var dt = new Date()

      let m = dt.getMonth()+1
      let a = dt.getFullYear()

      var yt = new Date()

      yt.setDate(dt.getDate() - 1);

      let dc = d.split(' ');

      let r = dc[0].split('-');
      let dd = parseInt(r[2])
      let dm = parseInt(r[1])
      let da = parseInt(r[0])

      if (a == da) {
        if (m == dm) {
          if (dt.getDate() == dd) {
            return 'Hoje'
          } else if (yt.getDate() == dd) {
            return 'Ontem'
          } else {
            return 'Dia '+r[2]
          }
        } else {
          let dfm = m - dm;
          if (dfm == 1) {
            return '1 mês atrás'
          } else {
            return dfm+' meses atrás'
          }
        }
      } else {
        return 'Dia '+r[2]+'/'+r[1]+'/'+r[0]
      }
    }

    public static dateYMD(d) {
      var dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/

      if (d && dateReg.test(d)) {
        // console.log(d);
        let dt = d.split('-');
        let f = dt[2]+'/'+dt[1]+'/'+dt[0];

        return new Date(dt[0], (dt[1]-1), dt[2]);
      } else {
        return '';
      }
    }

    public static dateYMDUTC(d) {
      var dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/

      if (d && dateReg.test(d)) {
        // console.log(d);
        let dt = d.split('-');
        let f = dt[2]+'/'+dt[1]+'/'+dt[0];

        let dts = new Date()

        return new Date(Date.UTC(dt[0], (dt[1]-1), dt[2], dts.getHours(), dts.getMinutes()));
      } else {
        return '';
      }
    }

    public static dateYMDUTCMoment(d) {
      var dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/

      if (d && dateReg.test(d)) {
        // console.log(d);
        //let dt = d.split('-');
        //let f = dt[2]+'/'+dt[1]+'/'+dt[0];

        //let dts = new Date()
        // new Date(Date.UTC(dt[0], (dt[1]-1), dt[2], dts.getHours(), dts.getMinutes()));
        let m = moment(d, "YYYY-MM-DD").utc();
        return m;
      } else {
        return '';
      }
    }

    public static nowUTC() {
      let dt = new Date()
      return new Date(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), dt.getHours(), dt.getMinutes()))
    }

    public static nowUTCMoment() {
      return moment().utc();
    }

    public static makeid(length) : string {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      }

    public static formatDistance(km: any, type = 'km') : string {
      //console.log(km, currentLocale.indexOf('en'), currentLocale.indexOf('pt'))
      if (type == 'mi') {
        km = (parseFloat(km) * 0.621371).toFixed(2) + ' Mi';
      } else {
        if (km > 1) {
          km = parseInt(km) + ' Km';
        } else {
          km = parseInt((parseFloat(km) * 100).toString()) + ' m';
        }
      }

      return km
    }

    public static getDistance(km: any, type = 'km') : string {
      //console.log(km, currentLocale.indexOf('en'), currentLocale.indexOf('pt'))
      if (type == 'mi') {
        km = (parseFloat(km) * 0.621371).toFixed(2) + ' Mi';
      } else {
        km = parseFloat(km).toFixed(2) + ' Km';
      }

      return km
    }

    public static gSlug(str) {
      const slugify = text => {
        // Use hash map for special characters
        let specialChars = {"à":'a',"ã":'a',"ä":'a',"á":'a',"â":'a',"æ":'a',"å":'a',"ë":'e',"è":'e',"é":'e',"ê":'e',"î":'i',"ï":'i',"ì":'i',"í":'i',"õ":'o',"ò":'o',"ó":'o',"ö":'o',"ô":'o',"ø":'o',"ù":'o',"ú":'u',"ü":'u',"û":'u',"ñ":'n',"ç":'c',"ß":'s',"ÿ":'y',"œ":'o',"ŕ":'r',"ś":'s',"ń":'n',"ṕ":'p',"ẃ":'w',"ǵ":'g',"ǹ":'n',"ḿ":'m',"ǘ":'u',"ẍ":'x',"ź":'z',"ḧ":'h',"·":'-',"/":'-',"_":'-',",":'-',":":'-',";":'-'};

          return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/./g,(target, index, str) => specialChars[target] || target) // Replace special characters using the hash map
            .replace(/&/g, '-E-')         // Replace & with 'and'
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '').toUpperCase();             // Trim - from end of text
      }

      if (str != null && str != undefined) {
        return slugify(str)
      } else {
        return ''
      }
    }

    public static number(str: number) {
      if (str == null || str == undefined) return '0,00'
      if (typeof str === 'string') {
        str = parseFloat(str)
      }
      return str.toLocaleString('pt-br', {minimumFractionDigits: 2});
    }

    public static money(str: number) {
      if (str == null || str == undefined) return 'R$ 0,00'
      if (typeof str === 'string') {
        str = parseFloat(str)
      }
      return str.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    }

    public static pad(str, size) {
      var s = String(str);
      while (s.length < (size || 2)) {s = "0" + s;}
      return s;
    }
 }
